document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("template-index")) return;

  const cursor = document.getElementById("custom-cursor");
  if (!cursor) return;

  // Move cursor
  window.addEventListener("mousemove", (e) => {
    cursor.style.transform =
      `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
  });

  // Hover state for links
  document.querySelectorAll("a").forEach((link) => {
    link.addEventListener("mouseenter", () => {
      cursor.classList.add("is-hovering");
    });

    link.addEventListener("mouseleave", () => {
      cursor.classList.remove("is-hovering");
    });
  });
});
